import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface WorldpayProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const WorldpayConfigurationCard = ({ processor }: WorldpayProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null

    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Worldpay Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Merchant Code</p>
                        <p className="font-mono text-sm">{options?.merchantCode || 'Not configured'}</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Service Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    {options?.clientKey && (
                        <div>
                            <p className="text-sm text-muted-foreground">Client Key</p>
                            <p className="font-mono text-sm">configured</p>
                        </div>
                    )}
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={options?.testMode ? 'outline' : 'default'}>
                            {options?.testMode ? 'Test' : 'Production'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const WorldpayProcessorDetailsPage = ({ processor }: WorldpayProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="worldpay" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <WorldpayConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
